import { SortDirections } from 'mbs-ui-kit/models/sort';
import { BrandingSetting, LicenseType } from 'mbs-ui-shared@models';
import { AccountTypeEnum } from './AccountTypeEnum';
import { AdministratorLicense } from './administrator-license';
import { AdministratorLicenseAvailabilityInfo } from './administrator-license-availability-info';
import Company from './Company';
import { QueryPagingParams } from './Paging';
import Permissions from './Permissions';
import { ProviderData } from './ProviderData';
import { ResellerInfo } from './Reseller';

export default class Administrator {
  public Id: string;
  public Email?: string = null;
  public Password?: string;
  public FirstName?: string = null;
  public LastName?: string = null;
  public Permissions?: Permissions = new Permissions();
  public Companies?: Company[];
  public DateCreated?: number = null;
  public LastLogin?: number = null;
  public Enabled? = true;
  public SendInstruction? = true;
  public Enabled2FA? = false;
  public IsProvider? = false;
  public IsSuperAdmin? = false;
  public IsReadOnly? = false;
  public IsWizardComplete? = true;
  public Is2FAEnabled? = false;
  public AccountType?: AccountTypeEnum = null;
  public AdministratorType?: AccountTypeEnum = null;
  public ProviderInfo?: ProviderData;
  public ResellerInfo?: ResellerInfo = null;
  public License?: AdministratorLicense;
  public AdminTrialLicences?: { [key: number]: AdministratorLicenseAvailabilityInfo };
  public SystemLicenses?: LicenseType[];
  public HasPurchasedRebrandingAndSslLicense?: boolean;
  public SignUpDate?: Date;

  public EnableOnlineAccess? = false;
  public EnableOnlineAccessConnect? = false;
  public EnableOnlineAccessBackupData? = false;
  public EnableOnlineAccessTickets? = false;

  public ForcedTwoFactorAuthDate: string;
  public BrandingSetting: BrandingSetting;

  // @casl/ability
  static modelName = 'Administrator';
}

export type AdministratorsFilters = {
  ids?: string[];
  search?: string;
  companyId?: string;
  enabled?: boolean;
  includeAllCompanies?: boolean;
};

export enum AdministratorsAPIFilterKeys {
  Search = 'search',
  Enabled = 'enabled'
}

export enum AdministratorsSortBy {
  Email = 'email',
  Company = 'company',
  License = 'license',
  FirstName = 'firstName',
  LastName = 'lastName',
  Enabled = 'enabled',
  DateCreated = 'dateCreated',
  LastLogin = 'lastLogin'
}

export interface AdministratorsSortParams {
  orderBy: `${AdministratorsSortBy}:${SortDirections}`;
}

export type AdministratorsSortFiltersParams = Partial<AdministratorsSortParams> & AdministratorsFilters;
export type AdministratorsQueryParams = AdministratorsSortFiltersParams & Partial<QueryPagingParams> & { ids?: string[] };
